import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-selection"
export default class extends Controller {
  static targets = ["moreInfoLink"]

  toggleCollapseText() {
    if (this.moreInfoLinkTarget.textContent.includes("See More Info")) {
      this.moreInfoLinkTarget.textContent = "Less Info -"
      this.moreInfoLinkTarget.classList.remove("mb-4")
    } else {
      this.moreInfoLinkTarget.textContent = "See More Info +"
      this.moreInfoLinkTarget.classList.add("mb-4")
    }
  }

  submit(event) {
    let form = window.$(event.target).parents(".product-card").find("form")[0]
    let button = event.target.closest(".btn")

    button.disabled = true
    form.submit()
  }
}
